import React, { Component } from 'react';
import styled, {keyframes} from 'styled-components'
import { Button, notification } from 'antd'
import {docCookies} from '../utils/docCookies'

const openNotificationWithIcon = (type) => {
  notification[type]({
    message: 'Activate Customer Service Remote View',
    description: 'Authorization code: '+Math.floor(Math.random()*10000),
    duration: null
  });
};

const ggtoken = '12e90c2f06bd4d1b893fc69905b258c8'
const mctoken = '30d3255517224b38a8c9030d7d54aaf4'

class Debug extends React.Component {

  state = {msg:'', isVisible:false, otherToken:""}

  componentDidMount() {
    const self = this
    window.onkeyup = function(e) {
      if (e.keyCode == 72 && (e.ctrlKey || e.metaKey) && e.altKey ){
     //it was Ctrl +  alt + H
     openNotificationWithIcon('info')
  }

      if (e.keyCode == 77 && (e.ctrlKey || e.metaKey) && e.altKey ){
     //it was Ctrl +  alt + M
     self.setState({
       isVisible: !self.state.isVisible,
       char: e.keyCode
     })

  }
    var key = e.keyCode ? e.keyCode : e.which;
}

  }

  changeToken(e){
    this.setState({otherToken: e.target.value})
  }

  render() {
    const {isVisible, otherToken} = this.state
    if (!isVisible) return null
    return (
      <div>
        <Button
          onClick={()=>docCookies.setItem('auth_token', ggtoken)}
        >
          mock gg
        </Button>
        <Button
          onClick={()=>docCookies.setItem('auth_token', mctoken)}
        >
          mock mc
        </Button>
        {/* <Button
          onClick={()=>docCookies.setItem('auth_token', 'fb504098d35c1ba67c0ec5b41fd32bf7')}
        >
          mock ggprod
        </Button> */}

        <input value={otherToken} onChange={this.changeToken.bind(this)}/>

        <Button
          onClick={()=>docCookies.setItem('auth_token', otherToken)}
        >
          mock using token: {otherToken}
        </Button>
      {this.props.children}
      </div>
    );
  }

}


const TestUrls = styled.div`
  background-color: pink;
  display: flex;
  flex-direction: column;
`

const CtrlOptM = () =>
  <Debug>
    <TestUrls>
      <a href="http://localhost:8080/start?rm_before_auth=true&rm_after_auth=true&rm_never=true">/start?rm_before_auth=true&rm_after_auth=true&rm_never=true ...</a>
      <a href="http://localhost:8080/login?rm_before_auth=true&rm_after_auth=true&rm_never=true">/login?rm_before_auth=true&rm_after_auth=true&rm_never=true ...</a>
      <a href="http://localhost:8080/signup?rm_before_auth=true&rm_after_auth=true&rm_never=true">/signup?rm_before_auth=true&rm_after_auth=true&rm_never=true ...</a>
      <a href="http://localhost:8080/trips?rm_before_auth=true&rm_after_auth=true&rm_never=true">/trips?rm_before_auth=true&rm_after_auth=true&rm_never=true ...</a>
      <b>unauthed</b>
      <a href="http://localhost:8080/trips">/trips => /signin => /trips</a>
      <a href="http://localhost:8080/password_resets/123/edit">/password_resets/123/edit</a>
      <a href="http://localhost:8080/password_resets/new">/password_resets/new</a>
      <a href="http://localhost:8080/manage_email_subscriptions/123">/manage_email_subscriptions/123</a>

      <a href="http://localhost:8080/signup?utm=test&wfemail=new@user.com">/signup?utm=test&wfemail=new@user.com => authFlow => /step-one</a>
      <a href="http://localhost:8080/premium?coupon=everlance20off&plan=yearly">/premium?coupon=everlance20off&plan=yearly => authFlow => /premium + modal</a>
      <a href="http://localhost:8080/start?coupon=everlance20off&plan=yearly">/start?coupon=everlance20off&plan=yearly => authFlow => /premium + modal</a>
      <a href="http://localhost:8080/start?signup_type=accountants">/start?signup_type=accountants => authFlow => /accountants</a>
      <a href="http://localhost:8080/start?redirect_to=enterprise">/start?redirect_to=enterprise => authFlow => /enterprise</a>
      <a href="http://localhost:8080/splash_message?title=welcome">/splash_message?title=welcome => ??</a>
      <a href="http://localhost:8080/data-exports?slt=test">/data-exports?slt=test => /data-exports</a>
      <a href="http://localhost:8080/data-exports?slt=incorrect">/data-exports?slt=incorrect => /signin(with error) => /login</a>
      <b>authed</b>
      <a href="http://localhost:8080/#/premium">/#/premium => /premium</a>
      <b>edge cases</b>
      <a href="http://localhost:8080/signup?utm=test&wfemail=new@user.com">/signup?utm=test&wfemail=matt@everlance.com (existing) => /login</a>
      <a href="http://localhost:8080/#/start?gt=3234d02c8ec24ab5996bbb63a183c06e&group_company_name=Instacart&group_image_url=https://everlance.s3.amazonaws.com/uploads/photo/2017-12-01-2d07d14c9f6e4fd3a0b5899fac181bfc/logo-green.png">/#/start?gt=3234d02c8ec24ab5996bbb63a183c06e&group_company_name=Instacart&group_image_url=https://everlance.s3.amazonaws.com/uploads/photo/2017-12-01-2d07d14c9f6e4fd3a0b5899fac181bfc/logo-green.png</a>




    </TestUrls>
  </Debug>

export default CtrlOptM



// WEBPACK FOOTER //
// ./src/core/CtrlOptM.jsx